import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authModal, setAuthModal] = useState({ open: false, tab: "login" });

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };

  const openAuth = useCallback((tab = "login") => setAuthModal({ open: true, tab }), []);
  const closeAuth = useCallback(() => setAuthModal((m) => ({ ...m, open: false })), []);
  const setAuthTab = useCallback((tab) => setAuthModal((m) => ({ ...m, tab })), []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, authModal, openAuth, closeAuth, setAuthTab }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
